
import { computed, defineComponent, reactive, ref } from "vue";
import { copyResult } from "../functions/copyResult"
import CountDown from "./CountDown.vue"
export default defineComponent({
  name: "Success",
  components: {CountDown},
  props: ["gridImage","handlesPopUp", "theDate", "outToggle", "toggleOut"],
  setup(props) {
    const { gridImage, handlesPopUp, theDate, outToggle, toggleOut } = props;
    // const handletoggle= ()=>{
    //   toggleOut.value = true
    // }
    const positionx= ref(0)
    const positiony= ref(0)
    const getposition= (event: any)=>{
      console.log(event);
      console.log("event");
      
      positionx.value = event.screenX;
      positiony.value = event.screenY;
    }
const link_url= ref("hell mary")
    const handleShare = ()=>{
        copyResult(gridImage)
        handlesPopUp("הועתק")
    }
    return { gridImage, link_url, handleShare, theDate, outToggle, toggleOut, positiony, positionx,getposition };
  },
});
